import { CALL_API } from '../../../middlewares/api';

import { DOMAIN_COOKIE } from '../../../constants';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT, FAILURE_LOGOUT } from './constants';
import { COOKIE_KEY_ACCESS, COOKIE_KEY_ID, COOKIE_KEY_USERNAME } from '../../../constants/cookie';

import { resetInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';

export function logoutUser(callback) {
    return dispatch => {
        deleteCookies();
        dispatch(resetInfos());
        dispatch(forceFetchPartners());
        dispatch(invalidateClientToken());
        if (callback) {
            callback();
        }
    };
}

const deleteCookie = name => {
    document.cookie =
        name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + DOMAIN_COOKIE;
};

function deleteCookies() {
    deleteCookie(COOKIE_KEY_USERNAME);
    deleteCookie(COOKIE_KEY_ACCESS);
    deleteCookie(COOKIE_KEY_ID);
}

const invalidateClientToken = () => {
    return {
        [CALL_API]: {
            endpoint: '/auth/logout',
            types: [REQUEST_LOGOUT, SUCCESS_LOGOUT, FAILURE_LOGOUT]
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/logout/actions.js